// @ts-ignore
// import {gsap} from "/node_modules/gsap/dist/gsap.js";
import {gsap} from 'gsap';
// @ts-ignore
import {ScrollTrigger} from 'gsap/ScrollTrigger';
// @ts-ignore
import {Draggable} from "gsap/all";
// @ts-ignore
import {InertiaPlugin} from "gsap/all";

import {Menu} from './Menu';
import {Hubs} from './Hubs';
import {Locations} from './Locations';
import {Utilities} from "./Utilities";
import {Silder} from "./Slider";
import {Scroll} from "./Scroll";
import {Alerts} from "./Alerts";
import {Accordions} from "./Accordions";
import {TextImage} from './TextImage';
import {ImageGallery} from './ImageGallery';
import { Institutions } from './Institutions';
import { MouseFollower } from './MouseFollower';
import {Forms} from './Forms';
import {Content} from "./Content";
import {Tracking} from "./Tracking";
import {Map} from "./Map";
import {Video} from "./Video";
import {Jumbotron} from "./Jumbotron";
import { WalkTheTalk } from './walk-the-talk';

// Declare GTM dataLayer array.
declare global {
  interface Window { dataLayer: any[]; }
}

//GTM tracker
let tracked:NodeListOf<HTMLElement> = document.querySelectorAll('[data-track-cta]');
let tracker:object = null;
if ( tracked.length > 0) {
  tracker = new Tracking(tracked);
}

// To have a unique instance
const utilities = new Utilities();
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(Draggable)
gsap.registerPlugin(InertiaPlugin)

// // If there's a SLIDER
// if (document.querySelectorAll('.splide').length != 0) {
//   new Silder(utilities);
// }


// // If there's MouseFollower -> homepage only for now
// if (document.querySelectorAll('.mouse-follower').length != 0) {
//   new MouseFollower();
// }

 // If there's ALERTS
 if (document.querySelectorAll('.site-alert').length != 0) {
   new Alerts();
 }

 // If there's ACCORDIONS
 if (document.querySelectorAll('.accordions').length != 0) {
   new Accordions();
 }

// // If there's a INSTITUTION module
// if (document.querySelectorAll('.module-institutions').length != 0) {
//   new Institutions();
// }

// // If there's a TEXT IMAGE module
// if (document.querySelectorAll('.module-text-image').length != 0) {
//   new TextImage(gsap);
// }

// // If there's a IMAGE GALLERY
// if (document.querySelectorAll('.module-image-gallery').length != 0) {
//   new ImageGallery(gsap);
// }

// // If there's a FORM
// if (document.querySelector('.module-form')) {
//   tracker = null ? tracker : new Tracking(tracked);
//   new Forms(tracker);
// }

// // If there's a MAP
// if (document.querySelector('.map')) {
//   new Map(utilities, gsap);
// }

// // If there's a VIDEO
// if (document.querySelector('.btn-video')) {
//   new Video();
// }

// If there's a jumbotron
// if (document.querySelector('.jumbotron')) {
//   new Jumbotron(gsap);
// }

// If there's a WalkTheTalk
if (document.querySelector('.walk-the-talk-wrapper')) {
  new WalkTheTalk(gsap, window['walkTheTalkObj']);
}

// // if we're on the job's hub (uses GTM tracker to manage AJAX)
// if (document.querySelector('.hub-jobs')) {
//   tracker = null ? tracker : new Tracking(tracked);
//   new Hubs(tracker);
// }

// if we're on the locations hub (uses GTM tracker to manage AJAX)
if (document.querySelector('.locations')) {
  tracker = null ? tracker : new Tracking(tracked);
  new Locations(tracker);
}

// Is in all pages
// -----------------------------------------
// new Content();
// new Menu();
// new Scroll(utilities, gsap); // parallax & show/hide menu
